








export default {
  name: 'nav-toggle'

  props: ['click', 'isOpen']
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/generic/NavToggle.vue